import '@/common/styles/index.less';
import '@ssc-ui/charts-react/es/index.less';
import '@ssc-ui/charts-react/dist/charts-react.min.css';

import React, { useState } from 'react';
import { ConfigProvider, Spin } from 'ssc-ui-react';

import { VueI18n } from '@/common/appCtx';
import { GFlags, GlobalContext } from '@/common/context';
import { getGFlags } from '@/common/context/helper';
import { PlainObject } from '@/common/types';
import { UserInfo } from '@/common/types/user';
import { useWorkforceEnums } from '@/store/workforce-enums';

import { useCheckGrayStation } from './store/gray-station';

const SSCConfigProvider = (props: any) => {
  return <ConfigProvider {...props} />;
};

const sscUILocale = (() => {
  const { locales } = __DEV__ ? require('ssc-ui-react/dist/ssc-ui-react-with-locales') : require('ssc-ui-react');
  const sscUILocales: Record<string, any> = {
    en: locales.en_US,
    id: locales.id_ID,
    'ms-my': locales.ms_MY,
    'pt-br': locales.pt_BR,
    th: locales.th_TH,
    ph: locales.tl_PH,
    vi: locales.vi_VN,
    'zh-tw': locales.zh_TW,
    'zh-cn': locales.zh_CN,
  };
  return sscUILocales[VueI18n?.locale] || sscUILocales.en;
})();

export interface AppProps {
  IS_IN_ADMIN?: boolean;
  data?: {
    userInfo?: UserInfo;
    globalFlags?: GFlags;
  } & PlainObject;
  children?: React.ReactNode | undefined;
}

function App(props: AppProps) {
  const { IS_IN_ADMIN, data, children } = props || {};
  const { userInfo, globalFlags, ...rest } = data || {};
  const [loading, setLoading] = useState(false);
  const getEnum = useWorkforceEnums.use.getEnum();
  const checkGrayStation = useCheckGrayStation.use.checkGrayStation();

  React.useEffect(() => {
    getEnum();
    checkGrayStation();
  }, [getEnum, checkGrayStation ]);

  if (__DEV__) {
    console.info('[React App]', 'is in admin?:', !!IS_IN_ADMIN, 'language:', VueI18n?.locale);
  }

  return (
    <React.StrictMode>
      <GlobalContext.Provider
        value={{
          IS_IN_ADMIN,
          loading,
          setLoading,
          restData: rest,
          userInfo,
          globalFlags: getGFlags({ userInfo, globalFlags }),
        }}
      >
        <SSCConfigProvider
          prefixCls={__SSCUI_REACT_PREFIX__}
          rcPrefixCls={__SSCUI_REACT_RC_PREFIX__}
          locale={sscUILocale}
        >
          <div className={__REACT_CONTAINER_PREFIX__}>
            <Spin size="large" mask tips="Loading" spinning={loading}>
              {children}
            </Spin>
          </div>
        </SSCConfigProvider>
      </GlobalContext.Provider>
    </React.StrictMode>
  );
}

export default App;
